import { render, staticRenderFns } from "./unsure-choice.vue?vue&type=template&id=5e05b7be&"
import script from "./unsure-choice.vue?vue&type=script&lang=js&"
export * from "./unsure-choice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports